"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthLong = exports.getMonthShort = exports.getMonthTwoDigit = exports.getMonthOrdinal = exports.getMonthNumeric = void 0;
var get_localised_date_property_1 = require("../utils/get-localised-date-property");
var pad_number_to_length_1 = require("../utils/pad-number-to-length");
/**
 * Returns a numerical representation of the month: 1, 2, ..., 12
 * @hidden
 */
var getMonthNumeric = function (_a) {
    var offsetUtcDate = _a.offsetUtcDate;
    return offsetUtcDate.getUTCMonth() + 1;
};
exports.getMonthNumeric = getMonthNumeric;
/**
 * Returns an ordinal string representation of the month: 1st, 2nd, ..., 12th
 * @hidden
 */
var getMonthOrdinal = function (params) {
    var month = exports.getMonthNumeric(params);
    return params.ordinalStringFormatter(month);
};
exports.getMonthOrdinal = getMonthOrdinal;
/**
 * Returns a two-digit string representation of the month: 01, 02, ..., 12
 * @hidden
 */
var getMonthTwoDigit = function (params) {
    var month = exports.getMonthNumeric(params);
    return pad_number_to_length_1.padNumberToLength(month, 2);
};
exports.getMonthTwoDigit = getMonthTwoDigit;
/**
 * Returns a short localised string representation of the month: Jan, Feb, ..., Dec
 * @hidden
 */
var getMonthShort = function (params) {
    return get_localised_date_property_1.getLocalisedDateProperty({
        date: params.date,
        languageTag: params.languageTag,
        ianaTimeZoneName: params.ianaTimeZoneName,
        property: 'month',
        format: 'short'
    });
};
exports.getMonthShort = getMonthShort;
/**
 * Returns a long localised string representation of the month: January, February, ..., December
 * @hidden
 */
var getMonthLong = function (params) {
    return get_localised_date_property_1.getLocalisedDateProperty({
        date: params.date,
        languageTag: params.languageTag,
        ianaTimeZoneName: params.ianaTimeZoneName,
        property: 'month',
        format: 'long'
    });
};
exports.getMonthLong = getMonthLong;
//# sourceMappingURL=month.js.map